import { useDispatch, useSelector } from 'react-redux';
import TripleStateSwitch from '../../../../../../../Shared/TripleStateSwitch/TripleStateSwitch';
import { actions } from '../../../../../../../../context';

const HasCommentsFilterSwitch = () => {
    const dispatch = useDispatch();
    const currentHasCommentsFilterValue = useSelector(
        (state) => state.daylight.codeHasCommentsFilter
    );

    const hasCommentsProps = {
        defaultState: getDefaultState(currentHasCommentsFilterValue),
        states: {
            falseState: {
                title: 'No',
                onClick: () =>
                    dispatch(actions.daylight.setCodeHasCommentsFilter(false)),
            },
            neutralState: {
                title: 'Both',
                onClick: () =>
                    dispatch(actions.daylight.setCodeHasCommentsFilter(null)),
            },
            trueState: {
                title: 'Yes',
                onClick: () =>
                    dispatch(actions.daylight.setCodeHasCommentsFilter(true)),
            },
        },
    };

    return (
        <div className="d-flex justify-content-between align-items-center mt-2">
            <span>Show Has Comments</span>
            <TripleStateSwitch {...hasCommentsProps} />
        </div>
    );
};

export const getDefaultState = (hasCommentsFilterValue) => {
    if (hasCommentsFilterValue === null) {
        return 'neutral';
    }
    return hasCommentsFilterValue.toString();
};

export default HasCommentsFilterSwitch;
